import { Counterparty } from "@common/types/counterparty";
import { NormalizedDescriptionInfo } from "@common/types/normalizedDescription";
import {
    RuleConditionType,
    TransactionRule,
    TransferRuleDirection,
} from "@common/types/transactionRule";
import React, { useMemo } from "react";
import { useIdCopy } from "@hooks/useIdCopy";
import { RuleCondition } from "./RuleCondition/RuleCondition";
import layoutStyles from "./RuleTagLayout.module.scss";

interface Props {
    rule: Pick<TransactionRule, "conditions" | "id">;
    counterparties: Counterparty[];
    normalizedDescriptions: NormalizedDescriptionInfo[];
    transferDirection?: TransferRuleDirection;
    hideEntityCondition?: boolean;
}

export const TransactionRuleConditions: React.FC<Props> = ({
    rule,
    transferDirection,
    hideEntityCondition,
    ...rest
}) => {
    const { getCopyProps } = useIdCopy({ label: "Rule" });
    const conditions = useMemo(() => {
        let filtered = rule.conditions;
        if (transferDirection) {
            filtered = filtered?.filter(
                (condition) =>
                    condition.transferDirection === transferDirection,
            );
        }
        if (hideEntityCondition) {
            filtered = filtered?.filter(
                (condition) =>
                    condition.conditionType !== RuleConditionType.ENTITY,
            );
        }
        return filtered;
    }, [rule.conditions, transferDirection, hideEntityCondition]);

    return (
        <div
            className={layoutStyles.grid}
            {...(conditions?.length ? getCopyProps(rule.id) : {})}
        >
            {conditions?.map((condition) => (
                <RuleCondition
                    key={condition.id}
                    condition={condition}
                    {...rest}
                />
            ))}
        </div>
    );
};
